<script lang="jsx">
export default {
  name: 'Status',
  functional: true,
  props: {
    pointColor: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
  },
  render(h, context) {
    const { pointColor, text } = context.props;
    const clickHandler = typeof context.listeners.click === 'function' ? context.listeners.click : () => {};
    return (
      <div class="flex items-center" onClick={clickHandler}>
        <div class="small-dot mr-1 bg-ddd" style={{ backgroundColor: pointColor }} />
        <span class="text-theme-black-650">{text}</span>
      </div>
    );
  }
}
</script>

<style lang="scss" scoped>
.small-dot {
  min-width: 8px;
  min-height: 8px;
  border-radius: 8px;
}
</style>